import {
  MetaFilterResponseCoeFiltersOffersFilters,
  ProductAdditionalInfoEntity,
  ResponsesCoeOfferResponse,
  ResponsesCoeOfferStrategyDirectionResponse,
} from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import { metaFilterToOptions } from '../../../utils/metaFilterToOptions';
import { CoesOfferEntityNormalized, DynamicCustomFiltersProps, VariationStyle } from '../types';

import { filterHasOptions, normalizeCustomFilter } from '.';

const normalizeVariationStyle = (additionalInfo: ProductAdditionalInfoEntity): VariationStyle => {
  switch (additionalInfo.displayTypeId) {
    case 1:
      return {
        icon: 'ArrowUp',
        color: 'feedback.success.default',
        hasVariation: true,
      };

    case 2:
      return {
        icon: 'ArrowDown',
        color: 'feedback.error.default',
        hasVariation: true,
      };

    case 3:
      return {
        icon: 'ArrowRight',
        color: 'brand.primary.principal',
        hasVariation: true,
      };

    default:
      return { hasVariation: false };
  }
};

export const normalizeCoesOffers = (
  data?: ResponsesCoeOfferResponse[] | null
): CoesOfferEntityNormalized[] => {
  if (!data) {
    return [];
  }

  return data.map(({ offer }) => {
    return {
      ...offer,
      productIdNormalized: offer.productId || '',
      productNameNormalized: `${offer.fantasyName} ${offer.asset}`,
      strategyNormalized: offer.strategy || '',
      riskRatingNormalized: offer.suitabilityProductRisk?.risk || '',
      riskRatingScoreNormalized: offer.suitabilityProductRisk?.scoreAdjusted || 0,
      maturityDateNormalized: Utils.Mask.DateFormat(offer.maturityDate, 'dd/MM/yyyy'),
      additionalInfoNormalized: (offer?.additionalInfo?.slice(0, 2) || []).map((item) => ({
        ...item,
        variation: normalizeVariationStyle(item),
        labelNormalized: item.description || '',
        valueNormalized: Utils.Mask.Percentage(item?.value || 0),
      })),
      minimumApplicationNormalized: offer.minimumApplication || 0,
      maximumApplicationNormalized: 1000000,
    };
  });
};

export const normalizeCoesFiltersFromMeta = (
  meta?: MetaFilterResponseCoeFiltersOffersFilters
): DynamicCustomFiltersProps => {
  if (!meta) {
    return { filters: [] };
  }

  const directions = metaFilterToOptions(meta.filter.direction);
  const strategies = metaFilterToOptions(meta.filter.strategy);

  const directionFilter = normalizeCustomFilter('direction', 'Direção', directions);

  const strategyFilter = normalizeCustomFilter('strategy', 'Estratégia', strategies);

  const filtersWithValues = [directionFilter, strategyFilter].filter(filterHasOptions);

  return { filters: filtersWithValues };
};

export const normalizeCoesFilters = (
  data?: ResponsesCoeOfferStrategyDirectionResponse | null
): DynamicCustomFiltersProps => {
  if (!data) {
    return { filters: [] };
  }

  const directionFilter = normalizeCustomFilter(
    'direction',
    'Direção',
    data.strategyDirectionFilter.direction
  );

  const strategyFilter = normalizeCustomFilter(
    'strategy',
    'Estratégia',
    data.strategyDirectionFilter.strategy
  );

  const filtersWithValues = [directionFilter, strategyFilter].filter(filterHasOptions);

  return { filters: filtersWithValues };
};
